import React, { useContext, useState, useEffect } from "react";
import { AutoSizer, List } from "react-virtualized";
import TransactionContext from "../../../../Contexts/Transaction";
import coins from "../../../../assets/Coinlist.json";
import styled from "styled-components";
import ModalCoins from "../../../../Components/ModalCoins";
import Close from "../../../../assets/images/modal/close.svg";

const CoinsTo = () => {
  const checkCurrencyTo = useContext(TransactionContext);
  let filterCoins = coins.filter((item) => item.memo === true);
  const [currencylistto, SetCurrencylistto] = useState(filterCoins);
  const HandleSelectto = (event) => {
    document.querySelector(".background_container").style.filter = "blur(0)";
    const newexchangenameto =
      event.currentTarget.querySelector(".exchangename_item")?.innerHTML;
    const newexchangesymbolto = event.currentTarget.querySelector(
      ".exchangesymbol_item"
    )?.innerHTML;
    const newexchangefullnameto = event.currentTarget.querySelector(
      ".exchangefullname_item"
    )?.innerHTML;
    const newexchangeiconto =
      event.currentTarget.querySelector(".exchangeicon_item")?.innerHTML;
    const newnetworkto =
      event.currentTarget.querySelector(".network_item")?.innerHTML;
    checkCurrencyTo.SetexchangeNameto(newexchangenameto);
    checkCurrencyTo.SetexchangeSymbolto(newexchangesymbolto);
    checkCurrencyTo.SetexchangeFullnameto(newexchangefullnameto);
    checkCurrencyTo.SetexchangeIconto(newexchangeiconto);
    checkCurrencyTo.Setcefishowto(!checkCurrencyTo.cefishowto);
    checkCurrencyTo.SetNetworkTo(newnetworkto);
    checkCurrencyTo.SetLoading(true);
    checkCurrencyTo.SetSelect(0);
  };

  useEffect(() => {
    if (checkCurrencyTo.searchto === "") {
      SetCurrencylistto(coins);
    } else {
      const currencyitemtwo = [...coins].filter(
        (o) =>
          o.symbol.toUpperCase().includes(checkCurrencyTo.searchto) ||
          o.fullname
            .toUpperCase()
            .includes(checkCurrencyTo.searchto.toUpperCase())
      );
      SetCurrencylistto(currencyitemtwo);
    }
  }, [checkCurrencyTo.searchto, coins]);

  const rowRenderer = function ({
    key, // Unique key within array of rows
    index, // Index of row within collection
    isScrolling, // The List is currently being scrolled
    isVisible, // This row is visible within the List (eg it is not an overscanned row)
    style, // Style object to be applied to row (to position it)
  }) {
    return (
      <li onClick={HandleSelectto} key={key} style={style}>
        <p>
          <div>
            <span className="exchangeicon_item">
              <em className={"icon-" + currencylistto[index].name}></em>
            </span>
            <span className="captal exchangename_item">
              {currencylistto[index].name}
            </span>
            <span className="captal exchangesymbol_item">
              {currencylistto[index].symbol}
            </span>
          </div>
          <span className="exchangefullname_item">
            {currencylistto[index].fullname}
          </span>
        </p>
        {currencylistto[index].network && (
          <small
            style={{ border: "1px solid #F39C12", color: "#F39C12" }}
            className={
              currencylistto[index].network
                ? "network_item network_active"
                : "network_item"
            }
          >
            {currencylistto[index].network
              ? currencylistto[index].network
              : null}
          </small>
        )}
      </li>
    );
  };

  return (
    <ModalCoins>
      <StyledcryptoInfo>
        <StyleClose onClick={checkCurrencyTo.HandleClose}>
          <img src={Close} alt="flashift" />
        </StyleClose>
        <h4>Select a token</h4>
        <input
          autoFocus
          className="search"
          type="text"
          placeholder="search ..."
          value={checkCurrencyTo.searchto}
          onChange={checkCurrencyTo.HandleSearchto}
        />
        <ul>
          <AutoSizer>
            {({ width, height }) => (
              <List
                width={width}
                height={height}
                rowCount={currencylistto.length}
                rowHeight={60}
                rowRenderer={rowRenderer}
                scrollToIndex={0}
              />
            )}
          </AutoSizer>
        </ul>
      </StyledcryptoInfo>
    </ModalCoins>
  );
};

export default CoinsTo;
const StyledcryptoInfo = styled.div`
  display: flex;
  flex-direction: column;
  height: 98%;
  overflow: hidden;
  position: relative;
  .exchangesymbol_item {
    display: none;
  }
  .exchangeicon_item {
    em {
      margin-right: 5px;
    }
  }
  h4 {
    color: #f39c12;
  }
  .ReactVirtualized__List {
    height: 100%;
    overflow: auto;
    margin: 10px auto 5px auto;
    padding-right: 10px;
    scrollbar-width: thin;
    scrollbar-color: #787b86 #c2c2c2;
    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-track {
      background: #c2c2c2;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #787b86;
      border-radius: 8px;
      border: 1px solid #ffffff;
    }
  }
  ul {
    flex: 1;
    margin-bottom: 10px;
  }
  li {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding: 7px 7px 2px 7px;
    cursor: pointer;
    display: flex;
    display: -ms-flexbox;
    flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    justify-content: space-between;
    transition: all 200ms;
    last-child {
      border-bottom: none;
    }
    .network_active {
      border-radius: 5px;
      height: 20px;
      min-width: 40px;
      text-align: center;
      padding: 1px 5px;
      position: relative;
      top: 13px;
    }
    em {
      font-size: 2rem;
      @media (max-width: 768px) {
        font-size: 1.5rem;
        margin-right: 5px;
      }
    }
    p {
      div {
        display: flex;
        display: -ms-flexbox;
        flex-wrap: erap;
        -ms-flex-wrap: wrap;
        font-size: 1.1rem;
        height: 30px;
        @media (max-width: 768px) {
          font-size: 1rem;
        }
        span {
          &:last-child {
            opacity: 1;
            position: relative;
            left: 6px;
            top: 3px;
          }
        }
      }
    }
    img {
      width: 21px;
    }

    &:hover {
      background: ${(props) => props.theme.color.ColorThree};
      em {
        color: ${(props) => props.theme.color.ColorEight};
      }
    }
    span {
      i {
        font-size: 1.4rem;
        margin-right: 5px;
        position: relative;
        top: 3px;
      }
      &:last-child {
        opacity: 0.5;
      }
    }
    > span {
      &:last-child {
        position: relative;
        top: 3px;
        width: 32px;
        height: 17px;
        text-align: center;
        margin-left: 6px;
        border-radius: ${(props) => props.theme.radius.RadiusTwo};
        padding-top: 1px;
        font-size: 0.8rem;
      }
    }
  }
  input {
    color: ${(props) => props.theme.color.ColorTwo};
    background: rgba(255, 255, 255, 0.1);
    width: 100%;
    padding: 13px 10px;
    border-radius: 8px;
    margin-top: 10px;
    font-size: 1.1rem;
  }
`;
const StyleClose = styled.button`
  position: absolute;
  right: 0;
  top: 0;
`;
